import * as currencyService from "@services/format/currency";

export function resolveBundleDiscount(amount, discount, currency) {
  const discountAmount = amount * discount;
  const discountedPrice = currencyService.formatPrice(amount - discountAmount, currency);

  return discountedPrice;
}
